// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_dist_xlsx_mini_min_js":"ed4dd6f39a9d63da","node_modules_xlsx_xlsx_mjs":"ab1d2e563b23486f","node_modules_html2canvas_dist_html2canvas_js":"ed135391c4f69a51","node_modules_canvg_lib_index_es_js":"ec404a5fbf895fa0"}[chunkId] + ".js";
};